import React, { useEffect, useState } from 'react';
import useStudents from '../hooks/useStudents';

const Scanner = () => {
  const [barcodeInput, setBarcodeInput] = useState('');
  const [message, setMessage] = useState('');

  const { scanStudent } = useStudents();
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (barcodeInput.charAt(barcodeInput.length - 1) === '.') {
      scanStudent(barcodeInput.substring(0, barcodeInput.length - 1)).then((res) => {
        if (res) {
          if (res.check_in_time) {
            setMessage(`Successfully checked in ${res.first_name} ${res.last_name}`);
          } else {
            setMessage(`Successfully checked out ${res.first_name} ${res.last_name}`);
          }
        }
      });
      setBarcodeInput('');
    }
  }, [barcodeInput]);

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      setBarcodeInput((prev) => prev + '.');
    } else if (e.key.match(/[0-9]/)) {
      setBarcodeInput((prev) => prev + e.key);
    }
  };

  return (
    <div>
      <h1 className="font-bold text-2xl">Focus on this page and scan with barcode scanner</h1>
      <h2 className="text-lg">{message}</h2>
    </div>
  );
};

export default Scanner;
